import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {IFebLocalisation} from 'src/app/shared/models/feb-localisation';
import {UtilsService} from 'src/app/shared/services/utils.service';
import {environment} from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FebLocationsService {

  options = {
    headers: new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'})
  };

  constructor(private http: HttpClient, private utilsService: UtilsService) {}

  private handleError(err: HttpErrorResponse) {
    console.error(`[FebLocationsService] Code erreur : ${err.status}`, err.error);
    return throwError(() => {
      return err
    });
  }

  getAll(): Observable<IFebLocalisation[]> {
    return this.http.get<IFebLocalisation[]>(environment.backendApiUrl + '/admin/feb-locations', this.options)
      .pipe(catchError((err) => this.handleError(err)));
  }

  create(localisation: IFebLocalisation): Observable<IFebLocalisation> {
    return this.http.post<IFebLocalisation>(environment.backendApiUrl + '/admin/feb-locations', localisation, this.options)
      .pipe(catchError((err) => this.handleError(err)));
  }

  update(id: string, localisation: IFebLocalisation): Observable<IFebLocalisation> {
    return this.http.put<IFebLocalisation>(environment.backendApiUrl + '/admin/feb-locations/' + id, localisation, this.options)
      .pipe(catchError((err) => this.handleError(err)));
  }

  delete(localisation: IFebLocalisation): Observable<any> {
    return this.http.delete<any>(environment.backendApiUrl + '/admin/feb-locations/' + localisation.id, this.options)
      .pipe(catchError((err) => this.handleError(err)));
  }

  exportFebLocationsData(): Observable<any> {
    return this.http.get(environment.backendApiUrl + "/admin/feb-locations/export/", {responseType: 'blob'}).pipe(catchError(this.utilsService.handleError));
  }

}
